import { Component, OnInit } from "@angular/core";
import { NbMenuItem, NbSidebarService } from "@nebular/theme";
import { ThemeService } from "@app/service/theme.service";
import { OktaAuthService, UserClaims } from "@okta/okta-angular";

@Component({
  selector: "app-dashboard-layout",
  templateUrl: "./dashboard-layout.component.html",
  styleUrls: ["./dashboard-layout.component.scss"],
  providers: [NbSidebarService]
})
export class DashboardLayoutComponent implements OnInit {
  public theme = "my-light-theme";
  menuItems: NbMenuItem[] = [
    {
      title: "Batch Job Dashboard",
      icon: "grid",
      link: "/lendingqb/batch-job-dashboard"
    },

    {
      title: "Servicing",
      icon: "layout-outline",
      children: [
        {
          title: "LQB Email",
          icon: "email",
          link: "/lendingqb/borrower-email"
        },
        {
          title: "LQB Email History",
          icon: "book-open",
          link: "/lendingqb/lqb_email_history"
        }
      ]
    },
    {
      title: "Sales",
      icon: "layout-outline",
      children: [
        {
          title: "Corp User Setup",
          icon: "book-open",
          link: "/lendingqb/corp-user-list"
        },
        {
          title: "Leads",
          icon: "book-open",
          link: "/lendingqb/lead-list"
        },
        {
          title: "Conversations",
          icon: "book-open",
          link: "/lendingqb/conversation-list"
        }
      ]
    },
    {
      title: "Operations",
      icon: "layers-outline",
      children: [
        {
          title: "LendingQB Search",
          icon: "book-open",
          link: "/lendingqb/lqb-loan-search"
        },
        {
          title: "States Title",
          icon: "book-open",
          link: "/lendingqb/title-tran"
        },
        {
          title: "Deed",
          icon: "book-open",
          link: "/lendingqb/deed-list"
        },
        {
          title: "eConsent History",
          icon: "book-open",
          link: "/lendingqb/lqb-econsent-tran"
        },
        {
          title: "MicroBilt Order(IBV)",
          icon: "book-open",
          link: "/lendingqb/microbilt-tran"
        },
        {
          title: "Finicity Order History",
          icon: "book-open",
          link: "/lendingqb/finicity-tran"
        },
        {
          title: "MERS",
          icon: "book-open",
          link: "/lendingqb/mers-view"
        },
        {
          title: "DMI Export",
          icon: "book-open",
          link: "/lendingqb/dmi-dashboard"
        },
        {
          title: "Mortgage Chat",
          icon: "book-open",
          link: "/lendingqb/mortgage-chat"
        }
      ]
    },
    {
      title: "Secondary",
      icon: "layers-outline",
      children: [
        {
          title: "Rate Sheet Dashboard",
          icon: "book-open",
          link: "/lendingqb/rate-sheet-dashboard"
        },
        {
          title: "Email Subscription",
          icon: "book-open",
          link: "/lendingqb/rate-sheet-email-subscription"
        }
      ]
    },
    {
      title: "Compliance",
      icon: "layers-outline",
      children: [
        {
          title: "Purchase Advice",
          icon: "cloud-download",
          link: "/lendingqb/lqb-docs-download"
        }
      ]
    },
    {
      title: "LendingMan",
      icon: "layers-outline",
      children: [
        {
          title: "Pipeline",
          icon: "book-open",
          link: "/lendingqb/lendingman-tran"
        }
      ]
    },

    {
      title: "National Processing",
      icon: "activity-outline",
      children: [
        {
          title: "Transactions",
          icon: "book-open",
          link: "/lendingqb/national-processing-all-tran"
        }
      ]
    },
    {
      title: "Broker Package",
      icon: "gift-outline",
      children: [
        {
          title: "Broker Package",
          icon: "book-open-outline",
          link: "/lendingqb/company-list"
        },
        {
          title: "Add Corp Users",
          icon: "book-open-outline",
          link: "/lendingqb/company-users-list"
        }
      ]
    },
    {
      title: "Broker Package Admin",
      icon: "gift-outline",
      children: [
        {
          title: "Docusign Grant",
          icon: "book-open-outline",
          link: "/lendingqb/docusign"
        }
      ]
    },
    {
      title: "Originator Commissions",
      icon: "credit-card-outline",
      children: [
        {
          title: "Commissions Metrics",
          icon: "book-open",
          link: "/lendingqb/comp-metrics"
        },
        {
          title: "Bonus Metrics",
          icon: "book-open",
          link: "/lendingqb/bonus-metrics"
        },
        {
          title: "Originators",
          icon: "book-open",
          link: "/lendingqb/comp-originator"
        },
        {
          title: "Generate Report",
          icon: "book-open",
          link: "/lendingqb/comp-originator-report"
        },
        {
          title: "Report Summary",
          icon: "book-open",
          link: "/lendingqb/comp-report-summary"
        }
      ]
    },
    {
      title: "Loan Application",
      icon: "gift-outline",
      children: [
        {
          title: "Loan Application",
          icon: "book-open-outline",
          link: "/loan-application/loan-application-home"
        }
      ]
    },
    {
      title: "Bulk Pricing",
      icon: "pricetags-outline",
      children: [
        {
          title: "Agency Bulk Pricing",
          icon: "pricetags-outline",
          link: "/correspondence/bulk-tape-upload"
        },
        {
          title: "NonQM Bulk Pricing",
          icon: "pricetags-outline",
          link: "/correspondence/bulk-tape-upload"
        },
        {
          title: "Bulk Pipeline",
          icon: "pricetags-outline",
          link: "/correspondence/bulk-pipeline"
        }
      ]
    }
  ];
  userClaims: UserClaims | undefined;
  constructor(
    private themeService: ThemeService,
    private sidebarService: NbSidebarService,
    private oktaAuth: OktaAuthService
  ) {}

  ngOnInit() {}

  async onActivate(event) {
    this.userClaims = await this.oktaAuth.getUser();
    this.menuItems = this.menuItems.map(menuItem => {
      if (
        menuItem.title === "Originator Commissions" &&
        this.userClaims.groups.includes("Accounts")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Originator Commissions" &&
        !this.userClaims.groups.includes("Accounts")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "National Processing" &&
        this.userClaims.groups.includes("Accounts")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "National Processing" &&
        !this.userClaims.groups.includes("Accounts")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Operations" &&
        this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Operations" &&
        !this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Compliance" &&
        this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Compliance" &&
        !this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Servicing" &&
        this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Servicing" &&
        !this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "LendingMan" &&
        this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "LendingMan" &&
        !this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Broker Package" &&
        this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Broker Package" &&
        !this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Broker Package Admin" &&
        this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Broker Package Admin" &&
        !this.userClaims.groups.includes("Admin")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "Bulk Pricing" &&
        this.userClaims.groups.includes("Correspondents")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Bulk Pricing" &&
        !this.userClaims.groups.includes("Correspondents")
      ) {
        menuItem.hidden = true;
      } else if (
        menuItem.title === "DMI Export" &&
        this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Secondary" &&
        this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Rate Sheet Dashboard" &&
        this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = false;
      } else if (
        menuItem.title === "Loan Application" &&
        this.userClaims.groups.includes("Corporate")
      ) {
        menuItem.hidden = false;
      } else if (
          menuItem.title === "Sales"

      ){
        menuItem.hidden = false;
      } else {
        menuItem.hidden = true;
      }
      return menuItem;
    });
  }
}
